<script lang="ts">
  import SectionObjetMetierList from '@/generated/sections/SectionObjetMetierList.vue';
  import Button from '@/framework/base/classes/Button';
  import { ColumnFilter } from '@/generated/classes/ListData';
  import ObjetMetier from '@/extend/classes/ObjetMetier';
  import moment from "moment";
  import { defineComponent } from "vue";

  export default defineComponent({
    extends: SectionObjetMetierList,
    name: 'SectionObjetMetierListExtend',
    components: {},
    data() {
      return {
        buttons: [] as Button[],
        verifDisabled: false
      };
    },
    computed: {
      canAdd(): boolean {
        return true;
      },
      addLabel(): string {
        return 'Vérifier écritures paies';
      },
      addDisabled(): boolean {
        return this.verifDisabled;
      },
      extraButtons(): Button[] {
        if (this.buttons.length == 0) {
          const synchro = new Button();
          synchro.label = 'Synchroniser';
          synchro.show = true;
          synchro.disabled = this.totalCount < 1;
          synchro.outlined = false;
          synchro.loading = false;
          synchro.callback = () => this.synchro(synchro);
          this.buttons.push(synchro);
        } else {
          const synchro = this.buttons[0];
          synchro.disabled = this.totalCount < 1;
        }
        return this.buttons;
      },
    },
    methods: {
      defaultFilter(): void {
        const columnFilter = new ColumnFilter();
        columnFilter.name = 'date';
        columnFilter.sortDescending = true;
        this.activeFilters.push(columnFilter);
      },
      getLabel(name: string, item: number, obj: unknown): string {
        const objetMetier = obj as ObjetMetier;
        let res = item == 0 || item == null ? '' : item.toString();
        if (name == 'date') {
          res = moment(objetMetier.date).format("DD/MM/YYYY HH:mm");
        } else {
          const column = this.listConfig.find(a => a.name == name);
          if (column) {
            const choix = column.choix.find(a => a.value == item);
            if (choix) {
              res = choix.text;
            }
          }
        }
        return res;
      },
      addItem(): void {
        this.verifDisabled = true;
        ObjetMetier.verifEcritures().then(() => {
          this.verifDisabled = false;
        });
      },
      synchro(button: Button): Promise<void> {
        button.loading = true;
        return new Promise((resolve) => {
          ObjetMetier.synchro().then(() => {
            this.loadTable();
            button.loading = false;
            resolve();
          })
        });
      },
    },
  });
</script>
